import React from 'react';
import {
  Phone,
  Plus,
  ArrowLeft,
  Loader2,
} from 'lucide-react';

/**
 * Step 4 — order summary, fee breakdown and purchase trigger.
 * @param {Object} props - selectedRecords, purchasing flag, fieldErrors, agent, onBack/onPurchase.
 */
export default function StepPurchase({ selectedRecords, purchasing, fieldErrors, agent, onBack, onPurchase }) {
  const count = selectedRecords.length;
  const isBulk = count > 1;
  const walletBal = agent?.walletBalance || 0;
  const cost = count * 1.00;

  return (
    <div className="space-y-4">
      <div>
        <div className="font-display font-bold text-lg">
          {isBulk ? `Confirm ${count}-number purchase` : 'Confirm purchase & activate line'}
        </div>
        <div className="text-xs text-white/55">
          {isBulk
            ? `We'll buy each number and run the full trust chain (SMS attach + STIR/SHAKEN A-attestation) sequentially. Numbers that fail are auto-released; successful ones stay live.`
            : `We'll buy this number and attach it to your Messaging Service.`}
        </div>
      </div>
      <div className="p-4 rounded-md border border-civix-border/50 bg-black/20 max-h-64 overflow-y-auto">
        <ul className="space-y-2">
          {selectedRecords.map((n) => (
            <li key={n.phoneNumber} className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-civix-purple shrink-0" />
              <span className="font-mono text-sm">{n.friendlyName || n.phoneNumber}</span>
              <span className="text-xs text-white/50">
                {n.locality ? `${n.locality}, ` : ''}{n.region || 'US'}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Ringy-Style Self-Funded Agent Wallet Notice */}
      <div className="p-3 rounded-md bg-civix-purple/10 border border-civix-purple/30 text-xs flex items-center justify-between">
        <span className="text-white/70">
          Agent Wallet Balance: <strong className="text-white">${walletBal.toFixed(2)}</strong>
        </span>
        <span className="text-civix-purpleSoft font-medium">
          Deduction: <strong className="text-emerald-400">-${cost.toFixed(2)}</strong> ($1.00/mo line fee)
        </span>
      </div>

      {fieldErrors._form && (
        <div role="alert" className="p-3 rounded-md border border-rose-500/50 bg-rose-500/10 text-sm text-rose-200">
          {fieldErrors._form}
        </div>
      )}
      <div className="flex items-center justify-between pt-1">
        <button onClick={onBack} disabled={purchasing} className="btn-ghost inline-flex items-center gap-1">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
        <button
          onClick={onPurchase}
          disabled={purchasing || count === 0}
          className="btn-primary inline-flex items-center gap-2 disabled:opacity-50"
        >
          {purchasing ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
          {purchasing
            ? (isBulk ? `Buying ${count}…` : 'Activating My Line…')
            : (isBulk ? `Buy ${count} numbers` : 'Activate My Line')}
        </button>
      </div>
    </div>
  );
}
